import { render, staticRenderFns } from "./VariableAdmin.vue?vue&type=template&id=5c943796&scoped=true&"
import script from "./VariableAdmin.vue?vue&type=script&lang=js&"
export * from "./VariableAdmin.vue?vue&type=script&lang=js&"
import style0 from "./VariableAdmin.vue?vue&type=style&index=0&id=5c943796&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c943796",
  null
  
)

export default component.exports